<rid-assignment-background />

@let mode = activity().content.mode;

@switch (mode.dataType) {
  @case ('RidLeeslijstAssignmentModeGeenTijd') {
    <rid-reading-matrix-no-time
      class="h-full"
      [matrices]="matrices()"
      [previousAccuracy]="mode.previousAccuracy"
      (finished)="finishReading($event.accuracy)"
    />
  }
  @case ('RidLeeslijstAssignmentModeStopwatch') {
    <rid-reading-matrix-stopwatch
      class="h-full"
      [matrices]="matrices()"
      [previousDuration]="previousStopwatchDuration()"
      [previousAccuracy]="previousStopwatchAccuracy()"
      (finished)="finishStopwatch($event.duration, $event.accuracy)"
    />
  }
  @case ('RidLeeslijstAssignmentModeTimer') {
    <rid-reading-matrix-timer
      class="h-full"
      [matrices]="matrices()"
      [duration]="mode.duration"
      [previousWordCount]="mode.previousWordCount"
      [previousAccuracy]="mode.previousAccuracy"
      (finished)="finishTimer($event.accuracy, $event.selection, $event.durationMs)"
    />
  }
}
